import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const CreateDoctor = lazy(() => import('@pages/doctors/CreateDoctor').then((m) => ({ default: m.CreateDoctor })));
const DoctorsList = lazy(() => import('@pages/doctors/DoctorsList'));
const EditDoctor = lazy(() => import('@pages/doctors/EditDoctor').then((m) => ({ default: m.EditDoctor })));

// Route Components
const DoctorTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('doctors-page-title')}>
        <DoctorsList />
      </PageWrapper>
    </Suspense>
  );
};

const DoctorFormPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('doctors-create-title')}>
        <CreateDoctor />
      </PageWrapper>
    </Suspense>
  );
};

const DoctorEditPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('doctors-edit-title')}>
        <EditDoctor />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  DoctorFormPage,
  DoctorTablePage,
  DoctorEditPage,
};
